import { createFileRoute } from '@tanstack/react-router'
import { WarehouseStockPage } from '@/features/warehouse/stock-list-page'

export const Route = createFileRoute('/_authenticated/warehouse/')({
  staticData: { title: 'Warehouse' },
  // The page reads its filters from the URL itself; this only types `warehouse` for the Locations links.
  validateSearch: (search: Record<string, unknown>) => search as { warehouse?: string },
  component: WarehouseStockPage,
})
